import React from 'react';
import {
  ApButtonGroup,
  ApButtonDanger,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import { StyledModal, TextContent } from './DeleteConfirmationModal.styles';

interface IProps {
  isOpen: boolean;
  isDisabled?: boolean;
  onDelete(): void;
  onClose(): void;
  value: string;
}

export const DeleteConfirmationModal: React.FC<IProps> = ({
  isOpen,
  isDisabled,
  onDelete,
  onClose,
  value,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      header="Delete classification rule"
      isDismissible
      hasClosed={onClose}
      footer={() => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onDelete} disabled={isDisabled}>
              Delete
            </ApButtonDanger>
          </ApButtonGroup>
        );
      }}
    >
      <TextContent>
        You are about to delete the classification rule for the group:
        <br /> {value}
        <br />
        <br />
        <b>
          Future spend for this group will not be automatically classified until
          a new rule is created.
        </b>
        <br />
        <br />
        Are you sure you want to delete the classification rule?
      </TextContent>
    </StyledModal>
  );
};
